/**
 * @description: 平台票管理
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="ticket-manage">
        <div class="list-tit" v-show="showTit">
            <ul class="clearfix">
                <li class="col-md-3" v-for="menuItem in menu" :key="menuItem.id">
                    <span class="col-md-10" @click="titClk(menuItem.id)">{{menuItem.name}}</span>
                </li>
            </ul>
        </div>
        <div class="list-con" v-show="!showTit">
            <!-- 平台类型 -->
            <div class="pls-list" v-show="show1">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>平台类型</h1>
                <p class="p-hint">注：显示顺序大的在显示端靠前</p>
                <el-row>
                    <el-button type="primary" class="pull-right" @click="plsAdd">新增平台类型</el-button>
                </el-row>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="pls_table">
                    <el-table-column prop="listorder" label="显示顺序"></el-table-column>
                    <el-table-column prop="name" label="平台类型"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="plsModify(scope.row)">修改</span>
                            <span class="text-blue" @click="plsDel(scope.row.id)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="pls_page"
                    :total="pls_total"
                    @current-change="getPlsTable">
                </el-pagination>
                <!-- 新增、修改 -->
                <div class="pls-edit-alert" ref="pls_edit_alert">
                    <el-form :model="pls_edit_form" label-width="120px">
                        <el-form-item label="显示顺序">
                            <el-input placeholder="请输入显示顺序" v-model="pls_edit_form.listorder"></el-input>
                        </el-form-item>
                        <el-form-item label="类型名称">
                            <el-input placeholder="请输入类型名称" v-model="pls_edit_form.name"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>



            <!-- 平台票设置 -->
            <div class="ptp-list" v-show="show2 && showPtpList">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>平台票设置</h1>
                <el-form :inline="true">
                    <el-form-item label="门店">
                        <el-select v-model="ptp_shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="平台类型">
                        <el-input v-model="ptp_tpl_txt" class="el-ellipsis" clearable placeholder="请选择平台类型" @focus="ptpTplSelect" @clear="ptpTplDel"></el-input>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="ptpAdd">新增平台票</el-button>
                        <el-button type="primary" @click="getPtpTable(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="ptp_table">
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column prop="group_name" label="平台类型"></el-table-column>
                    <el-table-column prop="name" label="名称"></el-table-column>
                    <el-table-column prop="discount_price" label="价格"></el-table-column>
                    <el-table-column prop="settlement_price" label="平台结算总价"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="ptpModify(scope.row)">修改</span>
                            <span class="text-blue" @click="ptpDel(scope.row.id)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="ptp_page"
                    :total="ptp_total"
                    @current-change="getPtpTable">
                </el-pagination>
                <!-- 平台类型 - 多选 -->
                <div class="export-wrap" ref="ptp_tpl_alert">
                    <el-checkbox :indeterminate="ptp_tpl_sign" v-model="ptp_tpl_all" @change="ptpTplAll">全选</el-checkbox>
                    <el-checkbox-group v-model="ptp_tpl_ids" @change="ptpTplChange">
                        <el-checkbox v-for="item in platform_list" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <!-- 新增、修改 -->
            <div class="ptp-edit" v-show="!showPtpList">
                <h2>{{ptp_edit_tit}}</h2>
                <el-form :model="ptp_edit_form" label-width="160px">
                    <el-form-item label="门店">
                        <el-select v-model="ptp_edit_form.shop_id" :disabled="ptp_edit_form.shop_disabled" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="平台类型" v-if="ptp_edit_id == ''">
                        <el-input v-model="ptp_tpa_txt" class="el-ellipsis" clearable placeholder="请选择平台类型" @focus="ptpTpaSelect" @clear="ptpTpaDel"></el-input>
                    </el-form-item>
                    <el-form-item label="平台类型" v-else>
                        <el-input v-model="ptp_tpa_txt" class="el-ellipsis" clearable placeholder="请选择平台类型" @focus="ptpTpaRadioSelect" @clear="ptpTpaRadioDel"></el-input>
                    </el-form-item>
                    <el-form-item label="平台票名称">
                        <el-input placeholder="请输入平台票名称" v-model="ptp_edit_form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input placeholder="请输入价格" v-model="ptp_edit_form.discount_price"></el-input>
                    </el-form-item>
                    <el-form-item label="平台结算价">
                        <el-input placeholder="请输入平台结算价" v-model="ptp_edit_form.settlement_price"></el-input>
                    </el-form-item>
                    <el-form-item label="财务分类收入明细设置">
                        <el-row class="cfs-edit-row">
                            <el-col>
                                <label class="el-form-item__label">门票收入</label>
                                <el-input placeholder="请输入金额" v-model="ptp_edit_form.ticket_settlement_price"></el-input>
                            </el-col>
                            <el-col>
                                <label class="el-form-item__label">A类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="ptp_edit_form.a_settlement_price"></el-input>
                            </el-col>
                        </el-row>
                        <el-row class="cfs-edit-row">
                            <el-col>
                                <label class="el-form-item__label">B类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="ptp_edit_form.b_settlement_price"></el-input>
                            </el-col>
                            <el-col>
                                <label class="el-form-item__label">C类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="ptp_edit_form.c_settlement_price"></el-input>
                            </el-col>
                        </el-row>
                        <el-row class="cfs-edit-row">
                            <el-col>
                                <label class="el-form-item__label">D类酒水收入</label>
                                <el-input placeholder="请输入金额" v-model="ptp_edit_form.d_settlement_price"></el-input>
                            </el-col>
                            <el-col>
                                <label class="el-form-item__label">房费收入</label>
                                <el-input placeholder="请输入金额" v-model="ptp_edit_form.time_settlement_price"></el-input>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="showPtpList=true">返回</el-button>
                        <el-button type="primary" @click="ptpEdit">确定</el-button>
                    </el-form-item>
                </el-form>
                <!-- 平台类型 - 单选 -->
                <div class="export-wrap" ref="ptp_tpa_radio_alert">
                    <!-- <el-radio-group> -->
                        <el-radio v-for="item in platform_list" :key="item.id" v-model="ptp_tpa_radio" :label="item">{{item.name}}</el-radio>
                    <!-- </el-radio-group> -->
                </div>
                <!-- 平台类型 - 多选 -->
                <div class="export-wrap" ref="ptp_tpa_alert">
                    <el-checkbox :indeterminate="ptp_tpa_sign" v-model="ptp_tpa_all" @change="ptpTpaAll">全选</el-checkbox>
                    <el-checkbox-group v-model="ptp_tpa_ids" @change="ptpTpaChange">
                        <el-checkbox v-for="item in platform_list" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                showTit: true,
                show1: false,
                show2: false,
                loading: false,
                shop_list: [],
                platform_list: [],
                ticket_type_list: [],
                ticket_package_type_list: [],
				week_list: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],

                // 门票类型
                pls_page: 1,
				pls_total: 0,
                pls_table: [],
                pls_edit_id: '',
                pls_edit_form: {
                    listorder: '',
                    name: ''
                },

                // 平台票设置
                showPtpList: true,
                ptp_shop_id: '',
                ptp_tpl_txt: '',
				ptp_tpl_sign: false,
				ptp_tpl_all: false,
                ptp_tpl_ids: [],
                ptp_page: 1,
				ptp_total: 0,
                ptp_table: [],
                ptp_edit_id: '',
                ptp_edit_tit: '',
                ptp_edit_form: {
                    shop_id: '',
                    shop_disabled: false,
                    name: '',
                    discount_price: '',
                    settlement_price: '',
                    ticket_settlement_price: '',
                    a_settlement_price: '',
                    b_settlement_price: '',
                    c_settlement_price: '',
                    d_settlement_price: '',
                    time_settlement_price: '',
                    group: [],
                    group_id: '',
                    group_name: ''
                },
                ptp_tpa_txt: '',
				ptp_tpa_sign: false,
				ptp_tpa_all: false,
                ptp_tpa_ids: [],
                ptp_tpa_radio: '',
                ptp_radio: '',
            }
        },
        computed: {
            menu() {
                let menu = {};
                if(!$.isEmptyObject(this.$store.state.menunew)) {
                    menu = JSON.parse(this.$store.state.menunew);
                    menu.forEach(_ => {
                        if(_.id == '1215') { // 门票
                            menu = _.submenu;
                            menu.forEach(v => {
                                if(v.id == '1222') { // 平台票管理
                                    menu = v.submenu;
                                }
                            })
                        }
                    })
                }
                return menu;
            },
        },
        created: function() {
            this.getShop()
            this.getTicketPlatform()
        },
        mounted: function() {
            
        },
        methods: {
            titClk: function(menu_id) {
                const _this = this

                _this.showTit = false
                _this.show1 = false
                _this.show2 = false
                if(menu_id == '1237') { // 平台类型设置
                    _this.getPlsTable(1)
                    _this.show1 = true
                } else if(menu_id == '1238') { // 平台票设置
                    _this.ptp_shop_id = _this.shop_list[0].id
                    _this.ptp_tpl_sign = false;
                    _this.ptp_tpl_all = false;
                    _this.ptp_tpl_ids = [];
                    _this.getPtpTable(1)
                    _this.show2 = true
                }
            },
            backFun: function() {
                this.showTit = true
                this.show1 = false
                this.show2 = false
            },
            // 获取门店
            getShop: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取购票平台
            getTicketPlatform() {
                const _this = this;

                Vue.axios.post('PublicData/api_getTicketGroup', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.platform_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            /*
             * 门票类型
             */
            // 列表
			getPlsTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('TicketGroup/getMerchantGroupList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.pls_total = Number(res.data.response.result.total);
						}
						_this.pls_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			plsDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('TicketGroup/delMerchantGroupData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功')
							_this.getPlsTable(_this.pls_page)
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			plsAdd() {
                this.pls_edit_id = ''
                this.pls_edit_form = {
                    listorder: '',
                    name: ''
                }
                this.plsEdit('新增平台类型')
			},
			// 点击修改
			plsModify(row) {
                this.pls_edit_id = row.id
                this.pls_edit_form = {
                    listorder: row.listorder,
                    name: row.name
                }
                this.plsEdit('修改平台类型')
            },
            // 新增、修改
			plsEdit(tit) {
                const _this = this;

                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: [tit, true],
                    area: ['500px', ''], // 宽高
                    content: $(_this.$refs.pls_edit_alert)
                }, function() {
                    let url = "TicketGroup/addMerchantGroupData";
                    let data = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "type": 1,
                                "listorder": _this.pls_edit_form.listorder,
                                "name": _this.pls_edit_form.name
                            }
                        },
                        "comment": ""
                    };
                    if(_this.pls_edit_id) {
                        data.request.param.id = _this.pls_edit_id;
                        url = "TicketGroup/editMerchantGroupData";
                    }
                    Vue.axios({
                        method: 'post',
                        url: url,
                        data: data
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.msg('操作成功')
                            _this.getPlsTable(_this.pls_page)
                            layer.closeAll()
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    });
                });
            },



            /*
             * 平台票设置
             */
            ptpTplSelect() {
                const _this = this;
                const c_ptp_tpl_ids = _this.ptp_tpl_ids,
                    c_ptp_tpl_sign = _this.ptp_tpl_sign,
                    c_ptp_tpl_all = _this.ptp_tpl_all;
                layer.confirm('', {
                    id: 'ptpTplAlert',
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['平台类型', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.ptp_tpl_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.ptp_tpl_ids = c_ptp_tpl_ids;
                        _this.ptp_tpl_sign = c_ptp_tpl_sign;
                        _this.ptp_tpl_all = c_ptp_tpl_all;
                    }
                }, function() {
                    let arr = [];
                    _this.platform_list.forEach(item => {
                        _this.ptp_tpl_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.ptp_tpl_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.ptp_tpl_ids = c_ptp_tpl_ids;
                    _this.ptp_tpl_sign = c_ptp_tpl_sign;
                    _this.ptp_tpl_all = c_ptp_tpl_all;
                });
            },
            ptpTplDel() {
				this.ptp_tpl_sign = false;
                this.ptp_tpl_all = false;
				this.ptp_tpl_ids = [];
            },
            ptpTplAll(val) {
                let ids = [];
				this.platform_list.forEach(v => {
					ids.push(v.id);
				});
				this.ptp_tpl_ids = val ? ids : [];
				this.ptp_tpl_sign = false;
			},
			ptpTplChange(val) {
				const len = val.length;
				this.ptp_tpl_sign = len > 0 && len < this.platform_list.length;
				this.ptp_tpl_all = len === this.platform_list.length;
            },
            getPtpTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('TicketGroup/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.ptp_shop_id,
                            "group_id": _this.ptp_tpl_ids
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.ptp_total = Number(res.data.response.result.total);
						}
						_this.ptp_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			ptpDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('TicketGroup/delData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getPtpTable(_this.ptp_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            ptpTpaRadioSelect() {
                const _this = this;
                const c_ptp_tpa_radio = _this.ptp_tpa_radio
                layer.confirm('', {
                    id: 'ptpTpaRadioAlert',
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['平台类型', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.ptp_tpa_radio_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.ptp_tpa_radio = c_ptp_tpa_radio
                    }
                }, function() {
                    // platform_list
                    console.log(_this.ptp_tpa_radio);
                    _this.ptp_tpa_txt = _this.ptp_tpa_radio.name
                    _this.ptp_edit_form.group_id = _this.ptp_tpa_radio.id
                    _this.ptp_edit_form.group_name = _this.ptp_tpa_radio.name
                    layer.close(layer.index);
                }, function() {
                    _this.ptp_tpa_radio = c_ptp_tpa_radio
                });
            },
            ptpTpaRadioDel() {
				this.ptp_edit_form.group_id = ''
                this.ptp_edit_form.group_name = ''
            },
            ptpTpaSelect() {
                const _this = this;
                const c_ptp_tpa_ids = _this.ptp_tpa_ids,
                    c_ptp_tpa_sign = _this.ptp_tpa_sign,
                    c_ptp_tpa_all = _this.ptp_tpa_all;
                layer.confirm('', {
                    id: 'ptpTpaAlert',
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['平台类型', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.ptp_tpa_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.ptp_tpa_ids = c_ptp_tpa_ids;
                        _this.ptp_tpa_sign = c_ptp_tpa_sign;
                        _this.ptp_tpa_all = c_ptp_tpa_all;
                    }
                }, function() {
                    let arr = [];
                    _this.platform_list.forEach(item => {
                        _this.ptp_tpa_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                                _this.ptp_edit_form.group.push({
                                    "group_id": item.id,
                                    "group_name": item.name
                                })
                            }
                        });
                    });
                    _this.ptp_tpa_txt = arr.join(',');
                    layer.close(layer.index);
                }, function() {
                    _this.ptp_tpa_ids = c_ptp_tpa_ids;
                    _this.ptp_tpa_sign = c_ptp_tpa_sign;
                    _this.ptp_tpa_all = c_ptp_tpa_all;
                });
            },
            ptpTpaDel() {
				this.ptp_tpa_sign = false;
                this.ptp_tpa_all = false;
				this.ptp_tpa_ids = [];
            },
            ptpTpaAll(val) {
                let ids = [];
				this.platform_list.forEach(v => {
					ids.push(v.id);
				});
				this.ptp_tpa_ids = val ? ids : [];
				this.ptp_tpa_sign = false;
			},
			ptpTpaChange(val) {
				const len = val.length;
				this.ptp_tpa_sign = len > 0 && len < this.platform_list.length;
				this.ptp_tpa_all = len === this.platform_list.length;
            },
            // 点击新增
            ptpAdd() {
                this.ptp_edit_id = ''
                this.ptp_edit_tit = '添加平台票'
                this.ptp_edit_form = {
                    shop_id: this.shop_list[0].id,
                    shop_disabled: false,
                    name: '',
                    discount_price: '',
                    settlement_price: '',
                    ticket_settlement_price: '',
                    a_settlement_price: '',
                    b_settlement_price: '',
                    c_settlement_price: '',
                    d_settlement_price: '',
                    time_settlement_price: '',
                    group: [],
                    group_id: '',
                    group_name: ''
                }
                this.ptp_tpa_txt = ''
                this.ptp_tpa_sign = false
                this.ptp_tpa_all = false
				this.ptp_tpa_ids = []
                this.showPtpList = false
			},
			// 点击修改
			ptpModify(row) {
                this.ptp_edit_id = row.id
                this.ptp_edit_tit = '修改平台票'
                this.ptp_edit_form = {
                    shop_id: row.shop_id,
                    shop_disabled: true,
                    name: row.name,
                    discount_price: row.discount_price,
                    settlement_price: row.settlement_price,
                    ticket_settlement_price: row.ticket_settlement_price,
                    a_settlement_price: row.a_settlement_price,
                    b_settlement_price: row.b_settlement_price,
                    c_settlement_price: row.c_settlement_price,
                    d_settlement_price: row.d_settlement_price,
                    time_settlement_price: row.time_settlement_price,
                    group: [],
                    group_id: row.group_id,
                    group_name: row.group_name
                }
                this.ptp_tpa_txt = row.group_name
                this.showPtpList = false
            },
            // 新增、修改
			ptpEdit() {
                const _this = this;

                let url = "TicketGroup/addData"
                let data = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": _this.ptp_edit_form.shop_id,
                            "name": _this.ptp_edit_form.name,
                            "discount_price": _this.ptp_edit_form.discount_price,
                            "settlement_price": _this.ptp_edit_form.settlement_price,
                            "ticket_settlement_price": _this.ptp_edit_form.ticket_settlement_price,
                            "a_settlement_price": _this.ptp_edit_form.a_settlement_price,
                            "b_settlement_price": _this.ptp_edit_form.b_settlement_price,
                            "c_settlement_price": _this.ptp_edit_form.c_settlement_price,
                            "d_settlement_price": _this.ptp_edit_form.d_settlement_price,
                            "time_settlement_price": _this.ptp_edit_form.time_settlement_price,
                            "group": _this.ptp_edit_form.group
                        }
                    },
                    "comment": ""
                }
                if(_this.ptp_edit_id) {
                    url = "TicketGroup/editData"
                    data = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "id": _this.ptp_edit_id,
                                "shop_id": _this.ptp_edit_form.shop_id,
                                "name": _this.ptp_edit_form.name,
                                "discount_price": _this.ptp_edit_form.discount_price,
                                "settlement_price": _this.ptp_edit_form.settlement_price,
                                "ticket_settlement_price": _this.ptp_edit_form.ticket_settlement_price,
                                "a_settlement_price": _this.ptp_edit_form.a_settlement_price,
                                "b_settlement_price": _this.ptp_edit_form.b_settlement_price,
                                "c_settlement_price": _this.ptp_edit_form.c_settlement_price,
                                "d_settlement_price": _this.ptp_edit_form.d_settlement_price,
                                "time_settlement_price": _this.ptp_edit_form.time_settlement_price,
                                "group_id":_this.ptp_edit_form.group_id,
                                "group_name": _this.ptp_edit_form.group_name
                            }
                        },
                        "comment": ""
                    }
                }
                Vue.axios({
                    method: 'post',
                    url: url,
                    data: data
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        layer.msg('操作成功')
                        _this.getPtpTable(_this.ptp_page)
                        _this.showPtpList = true
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    .list-tit {
        span {
            width: 100%;
            border: 1px solid #CCC;
            margin: 0 0 30px;
            line-height: 50px;
            font-size: 16px;
            text-align: center;
            cursor: pointer;
            border-radius: 10px;
        }
    }
    h1 {
        text-align: center;
    }
    .el-table {
        margin-top: 20px;
    }
    .cfs-edit-row {
        .el-col {
            width: 230px;
            margin-bottom: 10px;
        }
        label {
            width: 94px;
        }
        .el-input {
            width: 120px!important;
        }
    }

    .pls-edit-alert {
        display: none;
    }
    .ptp-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
		}
    }
</style>